import { TrackerEventType } from "src/core/model/TrackerEventType";
import { TrackerVariableType } from "src/core/model/TrackerVariableType";

import { EventListener } from "./EventListener";
import { NativeEventTrigger } from "./PageViewListener";

/**
 * Triggers COPY_PASTE event when the user pastes content.
 * Uses cooldown to prevent spam from rapid paste operations.
 */
export class CopyPasteListener implements EventListener {
  private trigger: NativeEventTrigger;
  private started = false;
  private boundHandler: ((e: ClipboardEvent) => void) | null = null;
  private cooldownMs: number;
  private lastTriggerTs = 0;

  constructor(trigger: NativeEventTrigger, cooldownMs = 2000) {
    this.trigger = trigger;
    this.cooldownMs = cooldownMs;
  }

  start(): void {
    if (this.started) return;
    this.started = true;

    this.boundHandler = () => {
      const now = Date.now();
      if (now - this.lastTriggerTs >= this.cooldownMs) {
        this.lastTriggerTs = now;
        this.trigger(TrackerEventType.COPY_PASTE);
      }
    };
    document.addEventListener("paste", this.boundHandler);
  }

  stop(): void {
    if (!this.started) return;
    this.started = false;

    if (this.boundHandler) {
      document.removeEventListener("paste", this.boundHandler);
      this.boundHandler = null;
    }
  }

  getTypes(): TrackerEventType[] {
    return [TrackerEventType.COPY_PASTE];
  }

  getVariableTypes(): TrackerVariableType[] {
    return [TrackerVariableType.INPUT_PASTE_RATIO];
  }
}
